// extracted by mini-css-extract-plugin
export default {"container":"PoliticasPrivacidad_container__MHmrk","content":"PoliticasPrivacidad_content__3cm8N","lastUpdate":"PoliticasPrivacidad_lastUpdate__dN7Qm"};